<template>
  <el-form ref="stationForm" :model="stationForm" :rules="stationRules" label-width="110px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备型号" prop="deviceModel">
          <el-input
            v-if="!isDetail()"
            v-model="stationForm.deviceModel"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ stationForm.deviceModel || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="出厂编号" prop="factoryNo">
          <el-input
            v-if="!isDetail()"
            v-model="stationForm.factoryNo"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ stationForm.factoryNo || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备状态" prop="status">
          <el-select v-if="!isDetail()" v-model="stationForm.status" style="width: 100%">
            <el-option
              v-for="item in typeList"
              :key="item.type"
              :label="item.typeName"
              :value="item.type"
            ></el-option>
          </el-select>
          <span v-else>{{ typeObj[stationForm.status] }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="采集器" prop="collector">
          <el-input
            v-if="!isDetail()"
            v-model="stationForm.collector"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ stationForm.collector || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="显示屏" prop="screen">
          <el-input
            v-if="!isDetail()"
            v-model="stationForm.screen"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ stationForm.screen || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="工作环境" prop="workEnv">
          <el-input
            v-if="!isDetail()"
            v-model="stationForm.workEnv"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ stationForm.workEnv || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="通信方式" prop="communication">
          <el-input
            v-if="!isDetail()"
            v-model="stationForm.communication"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ stationForm.communication || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="工作电流" prop="workCurrent">
          <el-input
            v-if="!isDetail()"
            v-model="stationForm.workCurrent"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ stationForm.workCurrent || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="休眠电流" prop="sleepCurrent">
          <el-input
            v-if="!isDetail()"
            v-model="stationForm.sleepCurrent"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ stationForm.sleepCurrent || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="扩展传感器" prop="extension">
          <el-input
            v-if="!isDetail()"
            v-model="stationForm.extension"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ stationForm.extension || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      typeList: [
        { type: 0, typeName: '启用' },
        { type: 1, typeName: '停用' }
      ],
      typeObj: {
        0: '启用',
        1: '停用'
      },
      stationForm: {}
    };
  },
  inject: ['isDetail'],

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.stationForm = newVal;
      }
    },
    stationForm: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
      }
    }
  },
  computed: {
    stationRules() {
      return {
        status: [{ required: !this.isDetail(), message: '请选择设备状态', trigger: 'change' }]
      };
    }
  },
  methods: {
    getNationNo() {
      // getNationNum().then(res => {
      //   if (!res.success) {
      //     return;
      //   }
      //   this.stationForm.mnNum = res.data
      // });
    },
    getData() {
      let data = {
        deviceModel: this.stationForm.deviceModel,
        factoryNo: this.stationForm.factoryNo,
        status: this.stationForm.status,
        collector: this.stationForm.collector,
        screen: this.stationForm.screen,
        workEnvironment: this.stationForm.workEnv,
        communicationMode: this.stationForm.communication,
        workingCurrent: this.stationForm.workCurrent,
        sleepCurrent: this.stationForm.sleepCurrent,
        extendedSensor: this.stationForm.extension
      };
      return data;
    },
    setData(data) {
      const {
        deviceModel,
        factoryNo,
        status,
        collector,
        screen,
        workEnvironment,
        communicationMode,
        workingCurrent,
        sleepCurrent,
        extendedSensor
      } = data;
      this.stationForm.deviceModel = deviceModel;
      this.stationForm.factoryNo = factoryNo;
      this.stationForm.status = status;
      this.stationForm.status = status;
      this.stationForm.collector = collector;
      this.stationForm.screen = screen;
      this.stationForm.workEnv = workEnvironment;
      this.stationForm.communication = communicationMode;
      this.stationForm.workCurrent = workingCurrent;
      this.stationForm.sleepCurrent = sleepCurrent;
      this.stationForm.extension = extendedSensor;
    },
    reset() {
      this.$refs.stationForm.resetFields();
    },
    validate() {
      let type;
      this.$refs.stationForm.validate(validated => {
        type = validated;
      });
      return type;
    }
  }
};
</script>
